import Footer from "./Foooter";
export default Footer;
